import { render, staticRenderFns } from "./install-page.vue?vue&type=template&id=b42c8e18&scoped=true&"
import script from "./install-page.vue?vue&type=script&lang=js&"
export * from "./install-page.vue?vue&type=script&lang=js&"
import style0 from "./install-page.vue?vue&type=style&index=0&id=b42c8e18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42c8e18",
  null
  
)

export default component.exports